"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Checkbox extends _react.Component {
  constructor(props) {
    var _context;
    super(props);
    this.state = {
      checked: this.props.checked || false
    };
    this.handleChange = (0, _bind.default)(_context = this.handleChange).call(_context, this);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.checked != this.props.checked) {
      this.setState({
        checked: this.props.checked
      });
    }
  }
  handleChange() {
    this.setState({
      checked: !this.state.checked
    }, () => {
      this.props.onChange(this.state.checked);
    });
  }
  render() {
    const {
      label: labelText,
      name,
      disabled,
      hasError = false,
      isRequired,
      isRequiredMarker,
      labelStyles = {}
    } = this.props;
    const showLabel = Boolean(labelText);
    const processedLabelText = `${labelText}${isRequired ? ` ${isRequiredMarker}` : ''}`;
    const {
      children,
      ...props
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_styles.StyledLabel, {
      labelStyles: labelStyles
    }, /*#__PURE__*/_react.default.createElement(_styles.StyledInput, (0, _extends2.default)({}, props, {
      id: name,
      type: "checkbox",
      disabled: disabled,
      checked: this.state.checked,
      onChange: this.handleChange,
      "aria-invalid": this.props['aria-invalid'],
      "aria-describedby": this.props['aria-describedby']
    })), /*#__PURE__*/_react.default.createElement(_styles.StyledCheckbox, {
      "data-testid": this.props.dataTestId,
      className: "checkmark",
      hasError: hasError
    }), children ? children : showLabel && /*#__PURE__*/_react.default.createElement(_styles.StyledSpan, {
      hasError: hasError
    }, processedLabelText));
  }
}
exports.default = Checkbox;
Checkbox.propTypes = {
  label: _propTypes.default.string,
  // Shows a label if it exists
  name: _propTypes.default.string,
  // Name for the label
  disabled: _propTypes.default.bool,
  // Disableds the checkbox
  checked: _propTypes.default.bool,
  // Checks the checkbox
  onChange: _propTypes.default.func,
  // Called when checkbox is checked/unchecked. Passed a boolean representing that state,
  dataTestId: _propTypes.default.string,
  // An optional testid to facilitate functional testing
  isRequired: _propTypes.default.bool,
  hasError: _propTypes.default.bool.isRequired,
  'aria-describedby': _propTypes.default.string,
  'aria-invalid': _propTypes.default.bool,
  isRequiredMarker: _propTypes.default.bool,
  labelStyles: _propTypes.default.objectOf(_propTypes.default.string),
  children: _propTypes.default.object
};
Checkbox.defaultProps = {
  label: '',
  disabled: false,
  checked: false,
  isRequired: false
};
Checkbox.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Checkbox",
  "props": {
    "label": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "checked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isRequired": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "name": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "dataTestId": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "hasError": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "aria-describedby": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "aria-invalid": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isRequiredMarker": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "labelStyles": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};